<ui-breadcrumb-nav
  [ariaLabel]="'cockpit.supplierContracts.details.breadcrumb.ariaLabel' | transloco"
>
  <ui-breadcrumb>
    <a [routerLink]="['/organizations', organizationId()]">
      <ng-icon name="heroHome" size="20" class="!block" />
      <span class="sr-only">
        {{ 'cockpit.supplierContracts.details.breadcrumb.dashboard' | transloco }}
      </span>
    </a>
  </ui-breadcrumb>
  <ui-breadcrumb>
    <a [routerLink]="['/organizations', organizationId(), 'supplier-contracts']">
      {{ 'cockpit.supplierContracts.details.breadcrumb.contracts' | transloco }}
    </a>
  </ui-breadcrumb>
  <ui-breadcrumb>
    <a
      [routerLink]="[
        '/organizations',
        organizationId(),
        'supplier-contracts',
        supplierContractId(),
      ]"
      aria-current="page"
    >
      {{ 'cockpit.supplierContracts.details.breadcrumb.contractDetails' | transloco }}
    </a>
  </ui-breadcrumb>
</ui-breadcrumb-nav>
